module.exports = __webpack_public_path__ + "img/WHITE_ALINEFORIEL-DESTEZET.1e2658ea.svg";